var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"dense":"","hide-details":"","label":_vm.label,"value":_vm.value,"input-value":_vm.inputValue},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }